import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {MessageService, SelectItem, MenuItem} from 'primeng/api';
import {ArticleService} from '../services/article.service';
import {
  APPLICATION,
  APPLICATIONSHEADER,
  EXECUTIONHEADER,
  JOBNAME,
  JOBNAMEHEADER,
  LOCATION,
  LOCATIONHEADER,
  RESOURCE,
  RESOURCEHEADER,
  SharedDataService
} from '../services/shared-data.service';
import {ResourcesService} from '../services/resource.service';
import {JobsService} from '../services/jobs.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StorageService} from '../services/storage.service';
import {Job} from '../domain/job';
import * as _ from 'underscore';
import {AuthenticationGuard} from '../oauth/authentication.guard';


@Component({
    selector: 'app-executions',
    templateUrl: './executions.component.html',
    styleUrls: ['./executions.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExecutionsComponent implements OnInit {
  progressSpinner = true;
  items: MenuItem[];
  home: MenuItem;
  resource: string;
  application: string;
  loc_pos: string;
  jobname: string;
  applications: SelectItem[];
  locations: SelectItem[];
  jobnames: SelectItem[];
  resources: SelectItem[];
  idToken;
  data: string[];
  jobs: Job[];
  DetailBox: boolean;
  resourceButtons: boolean;
  applicationButtons: boolean;
  locationButtons: boolean;
  jobButtons: boolean;
  jobForecast: Job[];
  jobPrevious: Job[];
  LastJobSelected: Job[];
  error: string;
  uri: string;
  header: string;
  ExecutionCard: boolean;
  cardOpen: boolean;
  cardOpenForecast: boolean;
  tabla: boolean;
  tablaForecast: boolean;
  cardIcon: string;
  cardIconForecast: string;
  activeIndex = 0;
  jobDetails=false;
  selectedLocation: any;

  constructor(private readonly jobsService: JobsService, private readonly resourcesService: ResourcesService,
              private readonly router: Router, private readonly sharedDataService: SharedDataService,
              private readonly storageService: StorageService,
              private readonly authorizationService: AuthenticationGuard,
              private readonly articleService: ArticleService,
              private readonly route: ActivatedRoute,
              private readonly messageService: MessageService) {

  }

  ngOnInit() {

   this.resource = RESOURCE;
   this.application = APPLICATION;
   this.loc_pos = LOCATION;
   this.jobname = JOBNAME;
   this.error = '';
    this.route.params.subscribe(params => {
      if(params['resource']!= '' && params['resource']!= null)
        this.resource = params['resource'];
      if(params['application']!= '' && params['application']!= null){
        this.decodificarURI(params['application']);
        this.application = this.uri;
      }
      if(params['location']!= '' && params['location']!= null)
        this.loc_pos = params['location'];
      if(params['jobname']!= '' && params['jobname']!= null)
        this.jobname = params['jobname'];
    });



      this.header = RESOURCEHEADER;
      this.items = [
      {label: RESOURCE,  command: (event: any) => {this.resourceNavBar(); }},
      {label: '', disabled : true, command: (event: any) => {this.aplicationNavBar(); }},
      {label: '', disabled : true, command: (event: any) => {this.locationNavBar(); }},
      {label: '', disabled : true, command: (event: any) => {this.jobNavBar(); }}
    ];
    this.header = RESOURCEHEADER;


    this.authorizationService.checkLogin();
    this.resources = [];
    this.applications = [];
    this.locations = [];
    this.jobs = [];
    this.cardOpen = false;
    this.cardOpenForecast = false;
    this.hideAllButtons();
    this.resourceButtons = false;
    this.DetailBox = true;
    this.jobForecast = [];
    this.jobPrevious = [];
    this.tabla = true;
    this.tablaForecast = true;
    this.LastJobSelected = [];
    this.getResources();
    this.ExecutionCard = true;
  }

  getResources(): void {
    this.idToken = this.storageService.getItem('encodedAccessToken');
    setTimeout(() => {
      this.resourcesService.getResources(this.idToken)
        .subscribe({
          next: (resources) => {
            this.data = resources;
          },
          error: (error) => {
            console.error('Error retrieving resource systems' + error);
            this.resources.push({label: 'AS400-AAA', value: 'AS400-AAA'});
            // In case authError the AAA data is retrieved
          },
          complete: () => {
            for (const item of this.data) {
              this.resources.push({label: item, value: item});
            }
          }
        });

    });
    if (this.resource !== RESOURCE) {
      this.resourceClicked(this.resource);
    }
  }

  getJobs(resource: string): void {
    setTimeout(() => {
      this.jobsService.getJobs(resource)
        .subscribe({
          next: (jobs) => {
            this.jobs = jobs['content'];
            this.listApplications();
            this.progressSpinner = true;
          }
        });
    });
  }

  listApplications(): void {
    this.applications = [];
     if (this.application !== APPLICATION) {
       this.applicationClicked(this.application);
     }
    this.jobs.forEach(job => {
        // If appFullName is not currently in the list, it is added (Distinct)
        if (_.findLastIndex(this.applications, {label: job.application, value: job.application}) < 0) {
          this.applications.push({label: job.application, value: job.application});
        }
      }
    );
    if (this.applications.length === 0) {
      this.messageService.add({key:'t1', severity: 'error', summary: 'Error Message', detail: 'Error listing applications'});
    }
    this.applications = _.sortBy(this.applications, 'value');
    if(_.findLastIndex(this.resources, {label: this.resource, value: this.resource}) < 0){
      this.messageService.add({key:'t1',severity: 'error', summary: 'Error Message', detail: 'Resource not found'});
      this.applications = [];
    }

  }

  listJobNames(): void {
    this.jobnames = [];


    this.jobs.forEach(job => {
      if (this.application === job.application && this.loc_pos === job.location
        && _.findLastIndex(this.jobnames, {label: job.jobName, value: job.jobName}) < 0) {
          this.jobnames.push({label: job.jobName, value: job.jobName}); }
    }
    );
    if (this.jobname !== JOBNAME) {
         this.jobClicked(this.jobname);
      }

    if (this.jobnames.length === 0) {
      this.messageService.add({key:'t1', severity: 'error', summary: 'Error Message', detail: 'Error listing job names'});
      this.DetailBox = true;
    }
    this.jobnames = _.sortBy(this.jobnames, 'value');
  }


  listLocations(): void {
    this.locations = [];
    if (this.loc_pos !== LOCATION) {
      this.locationClicked(this.loc_pos);
    }
    this.jobs.forEach(job => {
        // If location is not currently in the list, it is added (Distinct)
        if (this.application === job.application && _.findLastIndex(this.locations, {label: job.location, value: job.location}) < 0)
          this.locations.push({label: job.location, value: job.location});
      }
    );

    if (this.locations.length === 0) {
      this.messageService.add({key:'t1', severity: 'error', summary: 'Error Message', detail: 'Error listing locations'});
    }
    this.locations = _.sortBy(this.locations, 'value');

  }

  decodificarURI(url: string) {
    this.uri = decodeURI(url);

    if (this.uri === url) {
      return ; }
    else {
      this.decodificarURI(this.uri); }

  }

  resourceClicked(recurso) {

    this.applications = [];
    this.header = APPLICATIONSHEADER;
    this.items[0].label = recurso.toString();
    this.items[1].disabled = false;
    this.items[1].label = APPLICATION;
    this.progressSpinner = false;
    this.resource = recurso.toString();
    this.hideAllButtons();
    this.getJobs(this.resource);
    this.hideAllButtons();
    this.applicationButtons = false;
    this.resourceButtons = true;
    this.activeIndex = 1;
  }
  applicationClicked(app) {

    this.header = LOCATIONHEADER;
    this.items[1].label = app.toString();
    this.items[2].disabled = false;
    this.items[2].label = LOCATION;
    this.application = app.toString();

    this.hideAllButtons();
    this.applicationButtons = true;
    this.locationButtons = false;
    this.activeIndex = 2;
    this.listLocations();

  }
  locationClicked(location) {
    this.selectedLocation=location;
    this.header = JOBNAMEHEADER;
    this.items[2].label = location.toString();
    this.items[3].disabled = false;
    this.items[3].label = JOBNAME;
    this.loc_pos = location.toString();
    this.hideAllButtons();
    this.locationButtons = true;
    this.jobButtons = false;
    this.activeIndex = 3;
    this.listJobNames();
  }

  jobClicked(job) {
    this.header = EXECUTIONHEADER;
    this.items[3].label = job.toString();
    this.sharedDataService.setJob(job, this.resource);
    this.jobname = job.toString();
    this.hideAllButtons();
    this.jobButtons = true;
    this.DetailBox = false;
    this.ExecutionCard = false;
    this.jobDetails=true;
  }
  resourceNavBar() {
    this.resource = RESOURCE;
    this.application = APPLICATION;
    this.loc_pos = LOCATION;
    this.jobname = JOBNAME;
    this.items[1].disabled = true;
    this.items[2].disabled = true;
    this.items[3].disabled = true;
    this.hideAllButtons();
    this.resourceButtons = false;
    this.header = RESOURCEHEADER;


  }
  aplicationNavBar() {
    this.application = APPLICATION;
    this.loc_pos = LOCATION;
    this.jobname = JOBNAME;
    this.items[2].disabled = true;
    this.items[3].disabled = true;
    this.hideAllButtons();
    this.applicationButtons = false;
    this.header = APPLICATIONSHEADER;

  }
  locationNavBar() {
    this.loc_pos = LOCATION;
    this.jobname = JOBNAME;
    this.items[3].disabled = true;
    this.hideAllButtons();
    this.locationButtons = false;
    this.header = LOCATIONHEADER;
  }
  jobNavBar() {
    this.jobname = JOBNAME;

  }
  hideAllButtons() {

    this.resourceButtons = true;
    this.applicationButtons = true;
    this.locationButtons = true;
    this.jobButtons = true;
    this.DetailBox = true;
    this.ExecutionCard = true;
    this.cardOpen = false;
    this.cardOpenForecast = false;
    this.cardIcon = 'fa fa-plus';
    this.cardIconForecast = 'fa fa-plus';
    this.tabla = true;
    this.tablaForecast = true;


}

// go back
  goBackSteps(index:any) {
    if(this.activeIndex== 2){this.jobDetails=false;}
    for(let i=index+1;i<4;i++){
      this.items[i].label = null;
    }

  }

  goBack() {
   this.locationNavBar();
   this.locationClicked(this.selectedLocation);
    this.jobDetails=false;
  }
}
